export default __webpack_public_path__ + "static/media/Autofill.6a0c930e.svg";